import React from "react";
import OnboardingComponent, {
  OnboardingDataItem,
} from "./components/OnboardingComponent";
import { useTranslation } from "react-i18next";
import { notifyMobileAppToClose } from "../../common/helpers";

const CardCreationBlockedPage: React.FC = () => {
  const { t } = useTranslation();

  const noPaymentsOnboardingData: OnboardingDataItem[] = [
    {
      title: t("no_payments_title"),
      description: [t("no_payments_description"), t("no_payments_tip")],
      imageSrc: "/card/visa-card.svg",
    },
  ];

  return (
    <OnboardingComponent
      data={noPaymentsOnboardingData}
      finishLabel={t("back")}
      onFinish={() => notifyMobileAppToClose()}
    />
  );
};

export default CardCreationBlockedPage;
